import { createApp, ref } from 'vue';
import Menu from "./Menu";
import  { store } from './store';
import lang from './lang';

let app = createApp(Menu, { raw_links: 1 })

app.provide('lang', code => {
	const l = window.localStorage.getItem('user_lang');
	store.lang = l ? l : 'en';
	return lang[store.lang][code];
});
app.mount('#side-menu');
